import { useEffect } from 'react';
import { useRouter } from 'expo-router';
import { useCurrentChat } from '~/chat/hooks/useCurrentChat';
import { Chat } from '~/chat/components/chat/Chat';

/**
 * `/chat/:niceId` screen — just the conversation window; the surrounding chrome
 * (header, conversation list) lives in `ChatLayout`. `Chat` resolves the chat
 * off the same route param via `useCurrentChat`. Bounces back to the landing if
 * the niceId no longer resolves (e.g. the conversation was deleted), so the URL
 * never dangles on a dead chat.
 */
export const ChatNiceIdScreen = () => {
  const router = useRouter();
  const { chat, niceId, isLoading } = useCurrentChat();

  useEffect(() => {
    if (niceId && !isLoading && !chat) {
      router.replace('/chat');
    }
  }, [niceId, isLoading, chat, router]);

  return <Chat />;
};
